export const iconFontAwesomeDesignScissors = (
	<i className="fa-solid fa-scissors"></i>
);
